import { useState } from 'react'
import { ActiveUsersChart } from '../components/charts/ActiveUsersChart'
import { MediaAgeChart } from '../components/charts/MediaAgeChart'
import { MoneyChart } from '../components/charts/MoneyChart'
import '../styles/shared.scss'

export const Statistics = () => {
  const [year, setYear] = useState(new Date().getFullYear())

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i)

  return (
    <div className="page-container">
      <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
        <h2 className="page-title" style={{ marginBottom: 0 }}>
          Estadísticas
        </h2>
        <select
          className="form-select"
          value={year}
          onChange={e => setYear(Number(e.target.value))}
          style={{ width: 'auto' }}
        >
          {years.map(y => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
        <div className="stat-card">
          <h3>Ingresos por mes</h3>
          <MoneyChart selectedYear={year} />
        </div>
        <div className="stat-card">
          <h3>Usuarios activos por mes</h3>
          <ActiveUsersChart selectedYear={year} />
        </div>
        <div className="stat-card">
          <h3>Distribución por edad</h3>
          <MediaAgeChart />
        </div>
      </div>
    </div>
  )
}
